<template>
	<modal name="update-ios" :width="300" height="auto" @before-close="beforeClose">
		<div id="update-ios-modal">
			<p><strong>{{ $t('updateModal.ios.title') }}</strong></p>
			<p>{{ $t('updateModal.ios.text') }}</p>
			<button type="button" @click="refresh">{{ $t('updateModal.ios.refreshButton') }}</button>
		</div>
	</modal>
</template>

<script>
	import {Browser} from "@capacitor/browser";

	export default {
		name: "UpdateIosModal",
		data() {
			return {
			};
		},
		components: {
		},
		methods: {
			refresh() {
				const url = "https://apps.apple.com/us/app/mango-zp%C4%9Bvn%C3%ADk/id1462046181";
				Browser.open({ url: url });
			},
			beforeClose(e) {
				e.stop();
			}
		}
	}
</script>

<style lang="scss" scoped>
	#update-ios-modal {
		width: 100%;
		height: 100%;
		background-color: #264653;
		color: rgba(255, 255, 255, 0.8);
		font-size: 1.1em;

		p {
			margin: 0;
			padding: 20px 20px 0 20px;
			font-size: 0.9em;
			font-weight: 300;
			line-height: 1.2em;
		}

		button {
			width: 100%;
			height: 50px;
			padding: 0 20px;
			line-height: 50px;
			background: rgb(233,196,106); /* Old browsers */
			background: -moz-linear-gradient(left, rgba(233,196,106,1) 1%, rgba(244,162,97,1) 100%); /* FF3.6-15 */
			background: -webkit-linear-gradient(left, rgba(233,196,106,1) 1%,rgba(244,162,97,1) 100%); /* Chrome10-25,Safari5.1-6 */
			background: linear-gradient(to right, rgba(233,196,106,1) 1%,rgba(244,162,97,1) 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
			filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#e9c46a', endColorstr='#f4a261',GradientType=1 ); /* IE6-9 */
			font-weight: 300;
			color: rgba(255, 255, 255, 0.8);
			border: 0;
			margin: 20px 0 0 0;
			cursor: pointer;

			&:hover {
				opacity: 0.9;
			}
		}
	}
</style>
